import { getSecureItem, clearSecureStorage } from '@/shared/lib/storage'
import { AUTH_TOKEN_KEY, AUTH_HEADER_SCHEME } from '@/shared/constants/auth'
import { ROUTES } from '@/shared/constants/routes'
import { queryClient } from '@/shared/lib/tanstack'
import { router } from '@/app/providers/router-provider'
import { authClient } from './auth-client'

export async function getJwt(): Promise<string> {
  const sessionToken = await getSecureItem(AUTH_TOKEN_KEY)
  if (!sessionToken) return ''

  const { data, error } = await authClient.token({
    fetchOptions: {
      headers: { Authorization: `${AUTH_HEADER_SCHEME} ${sessionToken}` },
    },
  })

  if (error?.status === 401) {
    queryClient.clear()
    await clearSecureStorage()
    router.navigate({ href: ROUTES.LOGIN })
    throw new Error('Session expired')
  }

  if (error || !data?.token) throw new Error('Failed to get JWT')
  return data.token
}
